import request from '@/utils/axios.tool';
// 到账播报列表
export const arrivalBroadcastList = (data)=>{              
    return request.post(`/roleapi/promotingExcellence/arrivalBroadcastList`,data)
}
// 修改到账播报
export const editArrivalBroadcast = (data)=>{              
    return request.post(`/roleapi/promotingExcellence/editArrivalBroadcast`,data)
}